import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import TabSwitcher from '../../components/auth/TabSwitcher';
import CustomerRegister from './CustomerRegister';
import SellerRegister from './SellerRegister';
import Card from '../../components/common/Card';
import { theme } from '../../config/theme';

const Register = () => {
  const [activeTab, setActiveTab] = useState('customer');

  const tabs = [
    { value: 'customer', label: 'Customer' },
    { value: 'seller', label: 'Seller' },
  ];

  // Styles for the logo and name container
  const logoContainerStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing.sm,
    marginBottom: theme.spacing.md,
    textDecoration: 'none',
  };

  const logoTextStyles = {
    fontSize: theme.typography.fontSize['4xl'],
    fontWeight: theme.typography.fontWeight.bold,
    background: `linear-gradient(135deg, ${theme.colors.primary.main} 0%, ${theme.colors.primary.dark} 100%)`,
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    letterSpacing: '-0.5px',
  };

  return (
    <div style={{ width: '100%', maxWidth: '650px' }}>
      <div style={{ textAlign: 'center', marginBottom: theme.spacing['2xl'] }}>
        
        {/* Logo and Name Section */}
        <Link to="/" style={logoContainerStyles}>
          <img 
            src="/images/logo.png" 
            alt="AlarcTrade Logo" 
            style={{ 
              height: '48px', // Sized appropriate for the header
              width: 'auto', 
              objectFit: 'contain' 
            }} 
          />
          <span style={logoTextStyles}>
            AlarcTrade
          </span>
        </Link>

        <p style={{ fontSize: theme.typography.fontSize.base, color: theme.colors.text.secondary }}>
          Create your account to get started
        </p>
      </div>

      <Card padding="xl">
        <TabSwitcher activeTab={activeTab} onTabChange={setActiveTab} tabs={tabs} />
        <div style={{ display: activeTab === 'customer' ? 'block' : 'none' }}>
          <CustomerRegister />
        </div>
        <div style={{ display: activeTab === 'seller' ? 'block' : 'none' }}>
          <SellerRegister />
        </div>

        <div style={{ marginTop: theme.spacing.xl, textAlign: 'center', fontSize: theme.typography.fontSize.sm, color: theme.colors.text.secondary }}>
          Already have an account?{' '}
          <Link to="/login" style={{ color: theme.colors.primary.main, textDecoration: 'none', fontWeight: theme.typography.fontWeight.medium }}>
            Sign In
          </Link>
        </div>
      </Card>
    </div>
  );
};

export default Register;